import {getMessageValue} from "@ignitesales/neuro-application/src/i18n/messageUtil";

const getProductIcon = ({ locale='en', product }) => {
  return getMessageValue(locale, `productGroup.${product.groupType}.icon`) || null;
};

export default getProductIcon;
